// extracted by mini-css-extract-plugin
export default {"container":"style_container__lSqXi","dropArea":"style_dropArea__aRve2"};